import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// 이미지 임포트
import s5_img1 from '../../../assets/images/s5_img1.png';
import s5_img2 from '../../../assets/images/s5_img2.png';
import s5_img3 from '../../../assets/images/s5_img3.png';
import s5_img4 from '../../../assets/images/s5_img4.png';
import s5_img5 from '../../../assets/images/s5_img5.png';
import s5_img6 from '../../../assets/images/s5_img6.png';
import s5_img7 from '../../../assets/images/s5_img7.png';
import s5_img8 from '../../../assets/images/s5_img8.png';
import s5_img9 from '../../../assets/images/s5_img9.png';
import s5_img10 from '../../../assets/images/s5_img10.png';
import s5_img11 from '../../../assets/images/s5_img11.png';
import s5_img12 from '../../../assets/images/s5_img12.png';
import s5_img13 from '../../../assets/images/s5_img13.jpg';

export default function Section5() {

  const settings = {
    dots: false,
    infinite: true,
    speed: 3000,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0, 
    cssEase: 'linear', 
    pauseOnHover: false, 
    arrows: false, 
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  };

  const clients = [
    { img: s5_img1, alt: '1' },
    { img: s5_img2, alt: '2' },
    { img: s5_img3, alt: '3' },
    { img: s5_img4, alt: '4' },
    { img: s5_img5, alt: '5' },
    { img: s5_img6, alt: '6' },
    { img: s5_img7, alt: '7' },
    { img: s5_img8, alt: '8' },
    { img: s5_img9, alt: '9' },
    { img: s5_img10, alt: '10' },
    { img: s5_img11, alt: '11' },
    { img: s5_img12, alt: '12' },
    { img: s5_img13, alt: '13' },
  ];

  return (
    <>
      <div className="sect5 pt-7 pb-7">
        <div className="s5_content mb-4">
          <div className="txt-center">
            <p className="prt-medium fs-20 fc-005eed mb-1">Customers</p>
            <p className="prt-bold fs-50 fc-black1 lh-13">
              크림봇 고객사
            </p>
          </div>
        </div>

        <div className="clients_slider">
          <Slider {...settings}>
            
            {[...clients, ...clients].map((client, index) => (
              <div key={index} className="client-item">
                <div className="client-logo-container flex-center">
                  <img 
                    src={client.img} 
                    alt={client.alt} 
                    className="client-logo" 
                  />
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </>
  );
}